import { StackProps as MuiStackProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import cn from 'classnames';
import { useRootSelector } from '../../../../../../../../store/hooks';
import {
  selectSitePricingProductsData,
  selectSitePricingProductsMeta,
} from '../../../../../../store/features/products';
import { MuiStack } from '../../../../../../../../modules/material';
import AddToBasketButton, {
  AddToBasketButtonProps,
} from '../AddToBasketButton';
import PriceInfo from '../../../../../../shared/components/PriceInfo';
import PackageDiscounts from '../PackageDiscounts';
import VatMessage from '../VatMessage';
import CardCollapse from '../CardCollapse';
import {
  StyledActionsWrapper,
  StyledButtonWrapper,
  StyledDesktopOnly,
} from './styles';

export interface PackageSummaryPriceProps extends AddToBasketButtonProps {
  onCollapse: () => void;
  stackProps?: MuiStackProps;
}

export default function PackageSummaryPrice(props: PackageSummaryPriceProps) {
  const { onCollapse, stackProps, ...addToBasketButtonProps } = props;
  const theme = useTheme();
  const {
    totalCalculation: {
      startPrice,
      totalWithVipDiscount,
      totalInclVatWithVip,
      totalVatWithVip,
      tieredSaving,
      vipDiscount,
      packageDiscount,
    },
  } = useRootSelector(selectSitePricingProductsMeta);
  const { priceInclVat: isPriceInclVat, tier } = useRootSelector(
    selectSitePricingProductsData,
  );

  const finalPrice = isPriceInclVat
    ? totalInclVatWithVip
    : totalWithVipDiscount;
  const discounts = {
    tieredSaving,
    vipDiscount,
    packageDiscount,
  };

  return (
    <MuiStack
      direction="column"
      justifyContent="space-around"
      alignItems={{ xs: 'start', md: 'end' }}
      spacing={2}
      {...stackProps}
      className={cn(
        stackProps?.className,
        'informa-payment-package-summary-price',
      )}
    >
      <PriceInfo
        price={finalPrice}
        startPrice={startPrice}
        discountDetails={
          <PackageDiscounts
            finalPrice={finalPrice}
            initialPrice={startPrice}
            discounts={discounts}
            tieredSavingEndDate={tier.endDate}
            vat={<VatMessage vatAmount={totalVatWithVip} />}
          />
        }
        vat={<VatMessage vatAmount={totalVatWithVip} shortFormat />}
        boxWrapperProps={{
          sx: {
            [theme.breakpoints.down('md')]: {
              alignItems: 'start',
            },
          },
        }}
      />

      <StyledActionsWrapper>
        <StyledDesktopOnly>
          <CardCollapse onClick={onCollapse} />
        </StyledDesktopOnly>

        <StyledButtonWrapper>
          <AddToBasketButton
            type="submit"
            color="primary"
            fullWidth
            {...addToBasketButtonProps}
          />
        </StyledButtonWrapper>
      </StyledActionsWrapper>
    </MuiStack>
  );
}
